var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose-project-modal-content"},[_c('search-panel',{on:{"search":_vm.handleSearch,"add":_vm.handleAdd,"reset":_vm.handleReset}}),_c('choose-project-table',{ref:"table"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }